import {
  isMediaCardString,
  keyToMediaCardType,
  MediaCardType,
  mediaCardTypeStrings,
} from '@wandb/weave/common/types/media';

import {KeyTypes} from '../common';

export function isValidMediaKeyOption(
  key: string,
  keyTypes: KeyTypes,
  keys: string[],
  supportedMediaTypes: MediaCardType[] = mediaCardTypeStrings // default to all media types
) {
  const keyType = keyTypes[key];
  if (!keyType || !isMediaCardString(keyType)) {
    // This shouldn't happen since allMediaKeys should only contain media keys, but just checking before we get the media card type below.
    return false;
  }
  const mediaCardType = keyToMediaCardType(keyType);
  if (!supportedMediaTypes.includes(mediaCardType)) {
    // Switching to non-supported media types is not allowed in the media settings drawer
    return false;
  }

  if (keys.length === 0) {
    // If no keys are selected, we can switch to any supported media key
    return true;
  }
  const firstKeyType = keyTypes[keys[0]];
  if (!firstKeyType) {
    // If the first key type is not defined, we can't switch to any supported media key
    // because we don't know what the first key type is.
    return false;
  }
  const firstMediaCardType = isMediaCardString(firstKeyType)
    ? keyToMediaCardType(firstKeyType)
    : null; // if the existing selected key's type is not a media card string for whatever reason, we shouldn't allow adding any other media keys anyway.
  // If a key is selected, we can only switch to a key with the same type
  return mediaCardType === firstMediaCardType;
}
